export const controlModal = isOpen => ({
    type: 'CONTROL_MODAL',
    isOpen
})